var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"sumsub_box",attrs:{"visible":_vm.value},on:{"close":_vm.handleCancel}},[_c('div',{attrs:{"id":"sumsub-websdk-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }